module.exports = __webpack_public_path__ + "img/change.914f7dac.png";